import { ReactElement, useMemo } from 'react';
import styled from 'styled-components';
import { TOURNAMENT_CARD_WIDTH, TOURNAMENT_CARD_HEIGHT } from '~/components/casino-shared/tournaments/tournament-card';
import { EnhancedCategory } from '~/components/casino-shared/types';

const Unit = styled.div<{ colsCount: number; cardSize: { width: number; height: number } }>`
	display: grid;
	grid-template-columns: repeat(${({ colsCount }) => colsCount}, ${({ cardSize }) => cardSize.width}px);
	gap: 12px;
	height: ${({ cardSize }) => cardSize.height}px;
`;

const cardSizes = {
	xs: 104,
	m: 170,
	s: 350,
	l: 346
};

type GridType0Props = {
	itemDisplayType: keyof typeof cardSizes;
	categoryType: EnhancedCategory['type'];
};

export const getGridType0CardSize = ({ itemDisplayType, categoryType }: GridType0Props) => {
	if (categoryType === 'winner_feed') {
		return { width: 336, height: 104 };
	}

	if (categoryType === 'tournaments') {
		return { width: TOURNAMENT_CARD_WIDTH, height: TOURNAMENT_CARD_HEIGHT };
	}

	return {
		width: cardSizes[itemDisplayType],
		height: cardSizes[itemDisplayType]
	};
};

const GridType0 = <T extends ReactElement<unknown>[]>({
	GameCards,
	itemDisplayType,
	categoryType
}: { GameCards: T } & GridType0Props) => {
	const cardSize = useMemo(
		() => getGridType0CardSize({ itemDisplayType, categoryType }),
		[itemDisplayType, categoryType]
	);

	return (
		<Unit colsCount={GameCards.length} cardSize={cardSize}>
			{GameCards.map((GameCard, gameIdx) => (
				// eslint-disable-next-line react/no-array-index-key
				<div key={gameIdx}>{GameCard}</div>
			))}
		</Unit>
	);
};

export default GridType0;
